import { useEffect, useState } from "react";

export const privacyCensorChangedEvent = "privacyCensorSettingsChanged";

export const defaultPrivacyCensorSettings = {
  contactPhotos: false,
  contactNames: false,
  conversations: false,
  ticketMetaTags: false,
};

export const getPrivacyCensorStorageKey = userId =>
  `privacyCensorSettings:${userId || "default"}`;

export const normalizePrivacyCensorSettings = settings => ({
  ...defaultPrivacyCensorSettings,
  ...(settings || {}),
});

export const hasActivePrivacyCensor = settings =>
  Object.values(normalizePrivacyCensorSettings(settings)).some(Boolean);

export const getStoredPrivacyCensorSettings = userId => {
  try {
    return normalizePrivacyCensorSettings(
      JSON.parse(localStorage.getItem(getPrivacyCensorStorageKey(userId)) || "{}")
    );
  } catch {
    return defaultPrivacyCensorSettings;
  }
};

export const setStoredPrivacyCensorSettings = (userId, settings) => {
  const normalizedSettings = normalizePrivacyCensorSettings(settings);
  localStorage.setItem(
    getPrivacyCensorStorageKey(userId),
    JSON.stringify(normalizedSettings)
  );
  window.dispatchEvent(
    new CustomEvent(privacyCensorChangedEvent, {
      detail: normalizedSettings,
    })
  );
  return normalizedSettings;
};

export const usePrivacyCensorSettings = userId => {
  const [settings, setSettings] = useState(() =>
    getStoredPrivacyCensorSettings(userId)
  );

  useEffect(() => {
    setSettings(getStoredPrivacyCensorSettings(userId));

    const handlePrivacyCensorChanged = event => {
      setSettings(normalizePrivacyCensorSettings(event.detail));
    };

    window.addEventListener(
      privacyCensorChangedEvent,
      handlePrivacyCensorChanged
    );

    return () => {
      window.removeEventListener(
        privacyCensorChangedEvent,
        handlePrivacyCensorChanged
      );
    };
  }, [userId]);

  return settings;
};

export const getPrivateContactLabel = settings =>
  normalizePrivacyCensorSettings(settings).contactNames
    ? "Contacto privado"
    : null;

export const getPrivatePhoneLabel = settings =>
  normalizePrivacyCensorSettings(settings).contactNames
    ? "Telefono privado"
    : null;

export const getPrivateEmailLabel = settings =>
  normalizePrivacyCensorSettings(settings).contactNames ? "Correo privado" : null;

export const getPrivateMessageLabel = settings =>
  normalizePrivacyCensorSettings(settings).conversations ? "Mensaje privado" : null;
